<template>
  <div class="local">
    <div class="state-head">气象站状态（智慧农业系统）<div class="time" v-if="now_time">{{$moment(now_time*1000).format('YYYY-MM-DD HH:mm:ss')}}</div></div>
    <div class="state-content">
      <el-row :gutter="20">
        <el-col :xs="12" :sm="12" >
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24">
              <el-row class="state-row1" :gutter="10" v-if="geted">
                <StateBlock v-for="(item, index) in ['空气温度','空气湿度','光照度','风速','风向','大气压','雨雪','雨量','噪声','PM2.5','PM10','土壤温度','土壤湿度','土壤导电率','土壤氮','土壤磷','土壤钾','土壤PH','二氧化碳','氧气','一氧化碳','氨气','甲醛','硫化氢','臭氧','二氧化硫','氢气','甲烷']"
                            :key="index" :column="4" :allshow="true" :now_time="now_time" :tag="item" :obj="state[item]"></StateBlock>
              </el-row>

            </el-col>
            <el-col :xs="24" :sm="24" v-if="geted">
              <h2>设备联动</h2>
              <el-row :gutter="10">
                <el-col :xs="12" :sm="12" >
                  <div class="ctrl-block" :class="{'is-active':state1}" @click="openK('1')">
                    <el-row>
                      <el-col :xs="9" :sm="9" ><img src="images/wkxt.jpg" class="ctrl-icon" alt=""></el-col>
                      <el-col :xs="15" :sm="15" >
                        <div class="ctrl-state">
                          <div>
                            开启状态：
                            <el-switch
                                    v-model="state1"
                                    active-color="#13ce66">
                            </el-switch>
                          </div>
                          <div>水帘耗水： 3.2 m³ </div>
                          <div>风机能耗： 26.3 kW·h</div>
                          <div>工作时长： 18.3 小时</div>
                        </div>

                      </el-col>
                    </el-row>
                  </div>

                </el-col>
                <el-col :xs="12" :sm="12" >
                  <div class="ctrl-block" :class="{'is-active':state2}" @click="openK('2')">
                  <el-row>
                    <el-col :xs="9" :sm="9" ><img src="images/zwdxt.jpg" class="ctrl-icon" alt=""></el-col>
                    <el-col :xs="15" :sm="15" >
                      <div class="ctrl-state">
                        <div>
                          开启状态：
                          <el-switch
                                  v-model="state2"
                                  active-color="#13ce66">
                          </el-switch>
                        </div>
                        <div>植物灯功率： 1300 W</div>
                        <div>累计能耗： 26.3 kW·h</div>
                      </div>
                    </el-col>
                  </el-row>
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" >
                  <div class="ctrl-block" :class="{'is-active':state3}" @click="tips()">
                  <el-row>
                    <el-col :xs="9" :sm="9" ><img src="images/ggxt.jpg" class="ctrl-icon" alt=""></el-col>
                    <el-col :xs="15" :sm="15" >
                      <div class="ctrl-state">
                        <div>
                          开启状态：
                          <el-switch
                                  v-model="state3"
                                  active-color="#13ce66">
                          </el-switch>
                        </div>
                        <div>瞬间流量： 1.2 m³/h</div>
                        <div>累计流量： 71.2 m³</div>
                        <div>累计施肥： 19.8KG</div>
                      </div>
                    </el-col>
                  </el-row>
                  </div>
                </el-col>
                <el-col :xs="12" :sm="12" >
                  <div class="ctrl-block" :class="{'is-active':state4}" @click="tips()">
                  <el-row>
                    <el-col :xs="9" :sm="9" ><img src="images/zyxt.jpg" class="ctrl-icon" alt=""></el-col>
                    <el-col :xs="15" :sm="15" >
                      <div class="ctrl-state">
                        <div>
                          开启状态：
                          <el-switch v-model="state4" active-color="#13ce66"></el-switch>
                        </div>
                        <div>遮阳效率： 60%</div>
                        <div>遮阳帘： 12组</div>
                      </div>
                    </el-col>
                  </el-row>
                  </div>
                </el-col>

                <el-col :xs="20" :sm="20" >
<!--                  <div class="block">-->
<!--                    <span class="demonstration">显示间断点</span>-->
<!--                    <el-slider-->
<!--                            v-model="value7"-->
<!--                            :step="0.5"-->
<!--                            :max="24"-->
<!--                            show-stops>-->
<!--                    </el-slider>-->
<!--                  </div>-->
                </el-col>
              </el-row>
            </el-col>

          </el-row>

        </el-col>
        <el-col :xs="12" :sm="12" >
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" >
              <div id="chart1" :style="{width: '100%', height: '240px'}"></div>
            </el-col>
            <el-col :xs="24" :sm="24" >
              <div id="chart4" :style="{width: '100%', height: '240px'}"></div>
            </el-col>
            <el-col :xs="24" :sm="24" >
              <div id="chart2" :style="{width: '100%', height: '240px'}"></div>
            </el-col>
            <el-col :xs="24" :sm="24" >
              <div id="chart3" :style="{width: '100%', height: '240px'}"></div>
            </el-col>
          </el-row>

        </el-col>
      </el-row>

    </div>




  </div>
</template>

<script>
  import {formatTimeToStr} from "@/util/date";
  import StateBlock from "@/components/StateBlock";

  export default {
  name: 'Local',
  components: {StateBlock },
  mounted(){
  },
  data() {
    return{
      state:{"location":"玫瑰园","空气温度":{"value":25.8,"time":1617242525,"unit":"°C"},"空气湿度":{"value":70.6,"time":1617242525,"unit":"%RH"},"二氧化碳":{"value":516,"time":1617242526,"unit":"ppm"},"光照度":{"value":34836,"time":1617242527,"unit":"Lux"},"风速":{"value":2.1,"time":1617242528,"unit":"m/s"},"风向":{"value":"东南","time":1617242529,"unit":""},"雨雪":{"value":"无雨","time":1617242530,"unit":""},"土壤温度":{"value":24.3,"time":1617242531,"unit":"°C"},"土壤湿度":{"value":25.4,"time":1617264349,"unit":"%RH"},"土壤导电率":{"value":245,"time":1617242531,"unit":"us/cm"},"雨量":{"value":0,"time":1617242532,"unit":""},"土壤氮":{"value":0,"time":1616148391,"unit":"mg/kg"},"土壤磷":{"value":0,"time":1616148392,"unit":"mg/kg"},"土壤钾":{"value":0,"time":1616148392,"unit":"mg/kg"},"土壤PH":{"value":7.2,"time":1616148393,"unit":""},"一氧化碳":{"value":0,"time":1616148393,"unit":"ppm"},"氨气":{"value":1,"time":1616148393,"unit":"ppm"},"甲醛":{"value":0.01,"time":1616148394,"unit":"ppm"},"氧气":{"value":20.4,"time":1616148394,"unit":"%Vol"},"硫化氢":{"value":0,"time":1616148395,"unit":"ppm"},"臭氧":{"value":0.02,"time":1616148395,"unit":"ppm"},"二氧化硫":{"value":0.1,"time":1616148395,"unit":"ppm"},"氢气":{"value":0,"time":1616148396,"unit":"ppm"},"甲烷":{"value":0,"time":1616148396,"unit":"%LEL"},"噪声":{"value":45.7,"time":1616148397,"unit":"dB"},"大气压":{"value":100.3,"time":1616148397,"unit":"kPa"},"PM2.5":{"value":19,"time":1616148397,"unit":"μg/m³"},"PM10":{"value":26,"time":1616148398,"unit":"μg/m³"}},
      chartData: {},
      value7: 0,
      now_time:0,
      geted:true,
      state1: false,
      state2: false,
      state3: false,
      state4: false,
      websock:null,
    }
  },
  created: function () {
    // `this` 指向 vm 实例
    let that = this;
    this.initWebSocket();  //初始化继电器ws
    setTimeout(()=>{this.setAnalogData();},300)
    // setInterval(()=>{that.getData()},10000)
    that.now_time=new Date().getTime()/1000;
    setInterval(()=>{that.now_time=new Date().getTime()/1000;},1000)
  },
  destroyed() {
    this.websock.close() //离开路由之后断开websocket连接
  },
  methods: {
    setAnalogData(){
      {
        let temp ={
            "airRH24h": [71.07741935483872, 67.64833333333334, 62.627500000000005, 60.13833333333332, 58.923333333333325, 59.019327731092424, 59.038333333333334, 60.941666666666706, 63.3866666666667, 66.00833333333331, 69.49495798319327, 72.31333333333332, 74.94583333333334, 76.78249999999998, 79.0725, 80.81260504201684, 81.93999999999998, 82.71833333333335, 83.4308333333333, 85.13416666666669, 85.89416666666665, 86.17899159663867, 84.10749999999997, 79.74250000000002, 76.9],
            "airTemp24h": [26.00645161290322,26.700833333333332,27.76666666666666,28.24166666666666,28.653333333333332,28.717647058823523,28.520000000000007,27.74000000000002,26.880833333333317,25.940833333333313,25.170588235294115,24.639166666666657,24.20583333333332,23.90333333333335,23.55916666666666,23.3159663865546,23.154166666666637,23.091666666666647,23.055000000000007,22.749999999999975,22.644166666666635,22.627731092436935,23.38999999999999,24.452499999999997,25.040000000000003],
            "lux7d": [36008.30804597701,17504.124913013224,20608.14464534075,13070.261217391304,23596.50347705146,11064.30699617125,19495.237482614742,3796.213296398892],
            "rainfall30d": [0.0,3.0,6.0,12.0,0.0,0.0,3.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,12.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0,0.0],
            "soilRH24h": [25.425806451612917,25.405833333333387,25.322500000000026,25.1858333333333,25.005042016806733,24.866666666666713,24.708333333333307,24.532499999999995,24.436666666666707,24.33781512605046,24.26166666666666,24.211666666666638,24.179166666666628,24.148333333333298,24.114285714285664,24.098333333333283,24.077499999999965,24.03999999999998,23.985833333333346,23.94583333333337,23.90168067226896,23.890833333333386,23.88500000000005,23.88666666666671,23.880000000000003],
            "soilTemp24h": [24.125806451612906,24.75083333333333,25.583333333333353,26.215833333333396,26.446218487394972,26.5,26.5,26.40666666666675,26.11749999999997,25.821008403361294,25.510833333333366,25.232499999999956,25.009166666666694,24.81666666666664,24.636134453781466,24.484166666666688,24.34000000000004,24.22916666666663,24.11333333333328,24.008333333333333,23.92352941176476,23.82000000000003,23.800000000000026,23.91666666666669,24.0]
        }

        //处理过去24小时温度
        let x=[],y1=[],y2=[]
        for(let i =-1 ; i<24;i++){
          x.unshift(formatTimeToStr(new Date().getTime()-i*3600000,'h时'))
          y1.unshift(temp.airTemp24h.pop())
          y2.unshift(temp.soilTemp24h.pop())
        }
        this.drawChart1(x,y1,y2);


        //处理过去24小时湿度
        x=[],y1=[],y2=[]
        for(let i =-1 ; i<24;i++){
          x.unshift(formatTimeToStr(new Date().getTime()-i*3600000,'h时'))
          y1.unshift(temp.airRH24h.pop())
          y2.unshift(temp.soilRH24h.pop())
        }
        this.drawChart4(x,y1,y2);

        //处理过去7天光照
        x=[],y1=[]
        for(let i =0 ; i<7;i++){
          x.unshift(formatTimeToStr(new Date().getTime()-i*3600000*24,'M-d'))
          y1.unshift(temp.lux7d.pop())
        }
        this.drawChart2(x,y1);

        //处理过去30天降雨
        x=[],y1=[]
        for(let i =0 ; i<31;i++){
          x.unshift(formatTimeToStr(new Date().getTime()-i*3600000*24,'M-d'))
          y1.unshift(temp.rainfall30d.pop())
        }
        this.drawChart3(x,y1);
      }

    },
    getData(){
      let that = this;
      this.$api.getState(3)
          .then(res =>{
            console.log(res);
            this.geted = true;
            if(res.status === 200){
              let data = res.data.data;
              that.state = {}

              //处理最新状态
              for (let d of data.newest_state) {
                that.state.location = d["station_name"]

                let value=d["collect_data"]
                if(d["field_name"] === '风向'){
                  //处理风向
                  value = that.handelwd(value);
                }else if(d["field_name"] === '雨量'){
                  //处理非今天雨量
                  if(formatTimeToStr(d["collect_time"]*1000,'yyyy-MM-dd') != formatTimeToStr(new Date().getTime(),'yyyy-MM-dd')) value=0;
                }else if(d["field_name"] === '雨雪'){
                  //处理雨雪
                  value=value?'下雨中':'无雨';
                }

                that.state[d["field_name"]] = {value:value,time:d["collect_time"],unit:d["field_unit"]};

              }
              // console.log(111,JSON.stringify(that.state))
              //处理过去24小时温度
              let x=[],y1=[],y2=[]
              for(let i =-1 ; i<24;i++){
                let timekey = formatTimeToStr(new Date().getTime()-i*3600000,'yyyyMMddhh')
                x.unshift(formatTimeToStr(new Date().getTime()-i*3600000,'h时'))
                y1.unshift(data.airTemp24h[timekey+'-1'])
                y2.unshift(data.soilTemp24h[timekey+'-8'])
                // console.log(timekey)
              }
              that.drawChart1(x,y1,y2);


              //处理过去24小时湿度
              x=[],y1=[],y2=[]
              for(let i =-1 ; i<24;i++){
                let timekey = formatTimeToStr(new Date().getTime()-i*3600000,'yyyyMMddhh')
                x.unshift(formatTimeToStr(new Date().getTime()-i*3600000,'h时'))
                y1.unshift(data.airRH24h[timekey+'-2'])
                y2.unshift(data.soilRH24h[timekey+'-9'])
                // console.log(timekey)
              }
              that.drawChart4(x,y1,y2);

              //处理过去7天光照
              x=[],y1=[]
              for(let i =0 ; i<7;i++){
                let timekey = formatTimeToStr(new Date().getTime()-i*3600000*24,'yyyyMMdd')
                x.unshift(formatTimeToStr(new Date().getTime()-i*3600000*24,'M-d'))
                y1.unshift(data.lux7d[timekey+'-4']/1000)
                // console.log(timekey)
              }
              that.drawChart2(x,y1);

              //处理过去30天降雨
              x=[],y1=[]
              for(let i =0 ; i<30;i++){
                let timekey = formatTimeToStr(new Date().getTime()-i*3600000*24,'yyyyMMdd')
                x.unshift(formatTimeToStr(new Date().getTime()-i*3600000*24,'M-d'))
                y1.unshift(data.rainfall30d[timekey+'-11'])
                // console.log(timekey)
              }
              that.drawChart3(x,y1);


              // console.log( that.state)
            }
          })
          .catch(res =>{
            console.log(res)
          })
    },
    handelwd(d){
      //处理风向
      let wd=["北","东北","东","东南","南","西南","西","西北"];
      let d1= Math.round(d/45);
      return wd[d1];
    },
    random(len, min, max , bili=1){
      let arr=[]
      for (var i = 1; i <= 24; i++) {
        arr.push((Math.floor(Math.random() * (max - min)) + min)/bili)
      }
      return arr
    },
    drawChart1(x,y1,y2){
      // 基于准备好的dom，初始化echarts实例
      if(!this.chart1){
        this.chart1 = this.$echarts.init(document.getElementById('chart1'))
      }
      // 绘制图表
      let option = {
        title: {text: '过去24小时温度',},
        grid: {},
        legend: {data: ['空气温度', '土壤温度'], right: 10, top: 1},
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: x
        },
        yAxis: [{
          name: '温度(°C)',
          // max: 50,
          // min: 15,
          type: 'value',
        }],
        series: [{
          name: '空气温度',
          data: y1,
          type: 'line',
          smooth: true
        },{
          name: '土壤温度',
          color: '#2c3e50',
          data:  y2,
          type: 'line',
          smooth: true
        }]
      }
      this.chart1.setOption(option);
    },
    drawChart4(x,y1,y2){
      // 基于准备好的dom，初始化echarts实例
      if(!this.chart4){
        this.chart4 = this.$echarts.init(document.getElementById('chart4'))
      }
      // 绘制图表
      let option = {
        title: {text: '过去24小时湿度',},
        grid: {},
        legend: {data: ['空气湿度', '土壤湿度'], right: 10, top: 1},
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: x
        },
        yAxis: [{
          name: '湿度(%)',
          // max: 50,
          // min: 15,
          type: 'value',
        }],
        series: [{
          name: '空气湿度',
          data: y1,
          type: 'line',
          smooth: true
        },{
          name: '土壤湿度',
          color: '#2c3e50',
          data:  y2,
          type: 'line',
          smooth: true
        }]
      }
      this.chart4.setOption(option);
    },
    drawChart2(x,y1){
      // 基于准备好的dom，初始化echarts实例
      if(!this.chart2){
        this.chart2 = this.$echarts.init(document.getElementById('chart2'))
      }
      // 绘制图表
      let option = {
        title: {text: '过去7天光照度',},
        grid: {},
        // legend: {data: ['空气温度', '土壤温度'], right: 10, top: 1},
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: x
        },
        yAxis: [{
          name: '光照度(kLux)',
          // max: 50,
          // min: 15,
          type: 'value',
        }],
        series: [{
          name: '光照度',
          data: y1,
          color: '#e2cd00',
          type: 'line',
          areaStyle: {},
          smooth: true
        }]
      }
      this.chart2.setOption(option);
    },
    drawChart3(x,y1){
      // 基于准备好的dom，初始化echarts实例
      if(!this.chart3){
        this.chart3 = this.$echarts.init(document.getElementById('chart3'))
      }
      // 绘制图表
      let option = {
        title: {text: '过去30天降雨量',},
        grid: {},
        // legend: {data: ['空气温度', '土壤温度'], right: 10, top: 1},
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: x
        },
        yAxis: [{
          name: '降雨量(mm)',
          // max: 50,
          // min: 15,
          type: 'value',
        }],
        series: [{
          name: '降雨量',
          data: y1,
          color: '#4484ff',
          type: 'bar',
          areaStyle: {},
          smooth: true
        }]
      }
      this.chart3.setOption(option);
    },
    openK(tag){
      let data={
        "action":"state",
        target:tag,
        value:!this["state" + tag]
      }
      this.websocketsend(data)
    },
    handle(data){
      let obj=null,item=null;
      switch (data.action){
        case "state":
          this['state'+data.target]= data.value;
          break;

        case "sensor":
          obj=data.data
          if(obj.length>0){
            for(item of obj){
              // console.log(111,item,this.state)
              this.state[item["tag"]]["value"] = item["CD"];
              this.state[item["tag"]]["time"] = item["CT"];
            }

          }
          break;
      }
    },
    initWebSocket(){ //初始化weosocket
      const wsuri = location.protocol.substr(0,4)==="http"?"ws://192.168.0.10:1880/relay":"ws://127.0.0.1:1880/relay";
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen(){ //连接建立之后执行send方法发送数据
      let actions = {"test":"12345"};
      this.websocketsend(actions);
    },
    websocketonerror(){//连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e){ //数据接收
      // console.log(e.data)
      const redata = JSON.parse(e.data);
      this.handle(redata)
    },
    websocketsend(Data){//数据发送
      this.websock.send(JSON.stringify(Data));
    },
    websocketclose(e){  //关闭
      console.log('断开连接',e);
    },
    tips(){
      this.$notify({
        title: '提示',
        type:'info',
        message: '联动设备暂未连接上。',
        duration: 1200
      });
    }
  }
}
</script>

<style lang="scss">
.local {
  img{max-width: 100%;}
  .ctrl-icon{
    display: block;
  }
  .ctrl-block{
    position: relative;
    margin: 10px;
    border-radius: 20px;
    background: #808080;
    border: #929292 1px solid;
    overflow: hidden;
    &.is-active{
      background: #409eff;
      border: #85acff 1px solid;
    }
    &:after{
      content: '';
      position: absolute;
      top:0;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }
  .ctrl-state{
    padding: 14px 20px;
    color: #fff;
    line-height: 34px;
    font-size: 20px;
  }
  .state-head{
    position: relative;
    background: #409EFF;
    font-size: 18px;
    line-height: 50px;
    color: #fff;
    padding-left: 12px;
    .time{
      position: absolute;
      bottom:6px;
      right:5px;
      padding: 4px 14px;
      font-size: 20px;
      line-height: initial;
      color: #c9e3ff;
    }
  }
  .state-content{
    padding: 12px;
  }
  .state-row1{
    //margin-bottom: 12px;
  }
  .state-block{
    min-height: 90px !important;
    .tips{
      font-size: 18px !important;
      line-height: 34px !important;
      padding: 0 !important;
    }
    .value{
      line-height: 50px !important;
      font-size: 24px !important;

    }
    .offline-block-txt1{
      font-size: 24px !important;
      line-height: 28px !important;
    }
    .offline-block-txt2{
      font-size: 14px !important;
    }
    .el-progress{
      margin-top: 4px;
    }
    .el-progress-bar__outer {
      height: 40px !important;
    }
    .el-progress-bar__innerText{
      font-size: 22px;
    }
    .el-progress-bar__outer {
      background-color: #a2a3a5;
    }
  }
}

</style>
